import { emitAddToBasketEvent } from "./emitter.js";

export default (variationId, additionalWidgetClickTracking, additionalProductClickTracking, pageName) => {
    const promoAttributionFeatureValue = additionalWidgetClickTracking["wk.promo_AttributionFeature"][0].replace("{PAGE_NAME}", pageName);

    const itemOriginValue = pageName === "DetailViewSheet" ? "ads_AddOnSalesSheet" : "ads_AddOnSales";

    const event = {
        variationId: variationId,
        quantity: 1,
        itemOrigin: itemOriginValue,
        tracking: Object.entries({
            ...additionalWidgetClickTracking,
            ...additionalProductClickTracking,
            "wk.promo_AttributionFeature": [promoAttributionFeatureValue],
        }).reduce((acc, [key, value]) => {
            return {
                ...acc,
                [key]: value[0],
            };
        }, {}),
    };

    emitAddToBasketEvent(event);
};
